import React, { useEffect } from "react";
import { Link, useNavigate, useNavigation } from "react-router-dom";

export default () => {
  const navigation = useNavigate();
  useEffect(()=>{
    document.title = "RollingAdz: Chat" || "Default Title";
  },[])
  return (
    <div>
      <div className="main py-3" style={{height: "100vh" , display: "flex" , alignItems: "center"}}>
        <div className="container">
          <div className=" row allover_border" style={{ borderRadius: "30px" }}>
            
              <div className=" col-md-3 col-md-3 right_border searchbar d-flex flex-column" >
                <div className="d-flex pe-1 search_border">
                  <button className="bi-search searchbtn ps-4" />
                  <input
                    placeholder="search"
                    className="form-control searchText border-0 bi-search"
                  />
                </div>
                <div className=" bg-white  allContacts contect_border_rounded">
                  <div className="mt-2 pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_1.png")}
                        className="pimg"
                      />
                    </div>
                    <div className=" d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Rolling Ads</div>
                      <div className="frank_msg">
                        <span>install Location Request</span>
                        <br />
                        <span>Approved for the date and time</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  {/* <hr /> */}
                  {/* <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_1.png")}
                        className="pimg"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Rolling Ads</div>
                      <div className="frank_msg">
                        <span>install Location Request</span>
                        <br />
                        <span>Approved for the date and time</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div> */}
                  <hr />
                  <div className=" pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_1.png")}
                        className="pimg"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Rolling Ads</div>
                      <div className="frank_msg">
                        <span>install Location Request</span>
                        <br />
                        <span>Approved for the date and time</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  <hr />
                  <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/caht_img_2.png")}
                        className="pimg"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Jeff Johns</div>
                      <div className="frank_msg">
                        <span>Hino, 155,2012</span>
                        <br />
                        <span>JOb #452788</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  <hr />
                  <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_3.png")}
                        className="pimg"
                      />
                      <i className="bi bi-bell-fill profile_notification" />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Sam Ronaid</div>
                      <div className="frank_msg">
                        <span>Isuzu, N-series, 2010</span>
                        <br />
                        <span>JOb #672734</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  <hr />
                  <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_4.png")}
                        className="pimg"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">jasmes Smith</div>
                      <div className="frank_msg">
                        <span>BMW, 5-series, 2015</span>
                        <br />
                        <span>JOb #973653</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  <hr />
                  <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_5.png")}
                        className="pimg"
                      />
                      <i className="bi bi-bell-fill profile_notification" />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Fhilip Monroe</div>
                      <div className="frank_msg">
                        <span>Freigthliner, 2016</span>
                        <br />
                        <span>JOb #674521</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  <hr />
                  <div className="pcontact d-flex  align-items-center justify-content-around">
                    <div className="picon">
                      <img
                        src={require("../assets/img/chat_img_6.png")}
                        className="pimg"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center sub_tital">
                      <div className="massenger_name mb-1">Kyle Smith</div>
                      <div className="frank_msg">
                        <span>volkswaggon, type 1, 2009</span>
                        <br />
                        <span>JOb #689342</span>
                      </div>
                    </div>
                    <div className="msg_time">
                      <span className="massage_time">08:50</span>
                    </div>
                  </div>
                  {/* <hr /> */}
                </div>
              </div>

              <div className=" col-md-9 d-flex flex-column" >
                <div className=" d-flex flex-column " style={{height: "94vh"}} >
                  <div className=" p-top-info d-flex flex-row align-items-center ps-1 pe-1 justify-content-between">
                    <span className="picon d-flex flex-row justify-content-around align-items-center gap-1 py-3">
                      <img
                        src={require("../assets/img/chat_img_3.png")}
                        className="pimg_msg mx-2"
                      />
                      <div className="d-flex flex-column">
                        <div>
                          <span className="massenger_name">Jeff Johns</span>
                          <span className="ms-3">
                            last seen 12 minutes ago...
                          </span>
                        </div>
                        <span className="mt-1">Drive</span>
                      </div>
                    </span>
                    <button
                      className="btn more_detales_button"
                      onClick={() => navigation(-1)}
                      type="button"
                    >
                      <i
                        className="bi bi-x-circle  text-primary"
                        style={{ fontSize: "2rem" }}
                      />
                    </button>
                  </div>
                  <div className="allContacts  flex-grow-1" style={{ minHeight: 0 }}>
                    <div className="justify-content-center w-100 px-md-5 p-2">
                      <div className=" justify-content-center"> 
                        <div className=" text-center mt-1">
                          <span className="bg_secondary py-2 px-4 rounded-pill">
                            Yesterday
                          </span>
                        </div>
                        <div className="d-flex justify-content-center gap-3 my-3">
                          <div>
                            <img
                              src={require("../assets/img/chat_img_3.png")}
                              className="pimg_msg"
                            />
                          </div>
                          <div className=" my-auto p-2 text_msg_div w-100 justify-content-between d-flex">
                            <span>
                              photoshoot location has been Approved form the
                              data of 11/26/2022 @ 1:00 pm
                            </span>
                            <span>9:10</span>
                          </div>
                        </div>
                        <span className="ms-5 ps-4">Call ended</span>
                      </div>
                      <div className=" justify-content-center">
                        <div className="text-center mt-4">
                          <span className="bg_secondary py-2 px-4 rounded-pill">
                            Yesterday
                          </span>
                        </div>
                        <div className="d-flex justify-content-center gap-3 my-3">
                          <div>
                            <img
                              src={require("../assets/img/chat_img_3.png")}
                              className="pimg_msg"
                            />
                          </div>
                          <div className=" my-auto p-2 text_msg_div w-100 justify-content-between d-flex">
                            <span>
                              photoshoot location has been Approved form the
                              data of 11/26/2022 @ 1:00 pm
                            </span>
                            <span>9:10</span>
                          </div>
                        </div>
                        <span className="ms-5 ps-4">Call ended</span>
                      </div>
                      <div className=" justify-content-center">
                        <div className="d-flex justify-content-center gap-3 my-3">
                          <div>
                            <img
                              src={require("../assets/img/chat_img_3.png")}
                              className="pimg_msg"
                            />
                          </div>
                          <div className=" my-auto p-2 text_msg_div w-100 justify-content-between d-flex">
                            <span>Great, Thank you!</span>
                            <span>9:10</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="justify-content-center w-100 px-md-5 p-2">
                      <div className=" justify-content-center">
                        <div className="text-center mt-4">
                          <span className="bg_secondary py-2 px-4 rounded-pill">
                            Today
                          </span>
                        </div>
                        <div className="d-flex justify-content-center gap-3 my-3">
                          <div>
                            <img
                              src={require("../assets/img/chat_img_3.png")}
                              className="pimg_msg"
                            />
                          </div>
                          <div className=" my-auto p-2 text_msg_div w-100 justify-content-between d-flex">
                            <span>
                              photoshoot location has been Approved form the
                              data of 11/26/2022 @ 1:00 pm
                            </span>
                            <span>9:10</span>
                          </div>
                        </div>
                        <span className="ms-5 ps-4">Call ended</span>
                      </div>
                      <div className=" justify-content-center">
                        <div className="text-center mt-4">
                          <span className="bg_secondary py-2 px-4 rounded-pill">
                            Today
                          </span>
                        </div>
                        <div className="d-flex justify-content-center gap-3 my-3">
                          <div>
                            <img
                              src={require("../assets/img/chat_img_3.png")}
                              className="pimg_msg"
                            />
                          </div>
                          <div className=" my-auto p-2 text_msg_div w-100 justify-content-between d-flex">
                            <span>
                              photoshoot location has been Approved form the
                              data of 11/26/2022 @ 1:00 pm
                            </span>
                            <span>9:10</span>
                          </div>
                        </div>
                        <span className="ms-5 ps-4">Call ended</span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white input_div_bordertop">
                    <div className=" msg_wirting_place   d-flex  px-3 align-items-center">
                      <div>
                        <img
                          src={require("../assets/img/chat_img_3.png")}
                          className="pimg_msg mx-2"/>
                      </div>
                      <i class="bi bi-paperclip me-2"></i>
                      <i class="bi bi-send"></i>
                      <input
                        className="w-100 form-control"
                        placeholder="Enter message..."
                        type="text"
                        name
                        id
                      />
                     
                    </div>
                  </div>
                </div>
              </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};
